import { currencyDecimals, formatNumber, formatShortDate, CURRENCY_NAMES, STRIP_FUELS, INDEX_LABELS } from '@reperio-news/adh-www-common/src/shared/blocks/FinanceStrip/finance.js';

export function manualIndices(rates) {
	return Object.keys(INDEX_LABELS)
		.filter((key) => Number.isFinite(rates?.[key]?.value))
		.map((key) => ({ key, ...rates[key] }));
}

function change(current, previous, decimals) {
	if (!Number.isFinite(previous)) return null;
	const diff = Math.round((current - previous) * 10 ** decimals) / 10 ** decimals;
	return { direction: Math.sign(diff), text: formatNumber(Math.abs(diff), decimals) };
}

export function tickerItems(finance, pinned, showFuel, indices) {
	const items = [];
	for (const code of pinned) {
		const rate = finance?.bnr?.rates?.find((r) => r?.code === code);
		if (!Number.isFinite(rate?.rate)) continue;
		const decimals = currencyDecimals(code);
		// The feed normalizes to one unit; display the BNR quoted quantity.
		const multiplier = rate.multiplier > 1 ? rate.multiplier : 1;
		const quotedRate = rate.rate * multiplier;
		const quotedPrevious = Number.isFinite(rate.prev) ? rate.prev * multiplier : null;
		items.push({
			key: `cur_${code}`, group: 'currency', label: code === 'XAU' ? 'Aur' : code,
			title: `${CURRENCY_NAMES[code] || code} — curs de referință BNR · ${formatShortDate(finance.bnr.date)}`,
			value: formatNumber(quotedRate, decimals), unit: code === 'XAU' ? 'lei/g' : 'lei',
			quantity: multiplier > 1 ? multiplier : null,
			change: change(quotedRate, quotedPrevious, decimals),
		});
	}
	if (showFuel) for (const fuel of STRIP_FUELS) {
		const price = finance?.fuel?.prices?.[fuel.key];
		if (!Number.isFinite(price?.avg)) continue;
		items.push({
			key: `fuel_${fuel.key}`, group: 'fuel', label: fuel.label,
			title: `Preț mediu național ${fuel.label.toLowerCase()} standard · ${formatShortDate(finance.fuel.date)}`,
			value: formatNumber(price.avg, 2), unit: 'lei/l', change: change(price.avg, price.prevAvg, 2),
		});
	}
	for (const index of indices) items.push({
		key: `idx_${index.key}`, group: 'index', label: INDEX_LABELS[index.key],
		title: `${INDEX_LABELS[index.key]}${index.date ? ` · valabil de la ${formatShortDate(index.date)}` : ''}`,
		value: formatNumber(index.value, 2), unit: '%', change: change(index.value, index.previous, 2),
	});
	return items;
}
